/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import {
  Form, FormGroup, Label, ListGroup, ListGroupItem, Spinner,
} from 'reactstrap';
import LaddaButton, { EXPAND_RIGHT } from 'react-ladda';
import PropTypes from 'prop-types';

import ModalShareHolder from '../../Modal/ModalShareHolder';
import ModalConfirm from '../../Modal/ModalConfirm';

const RelatedPeopleTab = ({
  person,
  shareHolders,
  setPersonData,
  services,
  onboarding, 
  Link,
  holder,
  userSession,
}) => {
  const [modalShareHolder, setModalShareHolder] = useState({
    open: false,
    loading: false,
    initialShareHolder: undefined,
  });
  const [modalConfirm, setModalConfirm] = useState({
    open: false,
    shareHolderId: null,
    title: '',
    callback: undefined,
    loading: false,
  });

  const handleSaveShareHolder = (shareHolder) => {
    const newShareHolder = {
      ...shareHolder,
    };

    const body = {
      person: {
        PersonId: person.PersonId,
        ShareHolder: [newShareHolder],
      },
      edit: true,
    };
    setModalShareHolder((m) => ({
      ...m,
      loading: true,
    }));
    if (onboarding){
      let docs = person.ShareHolder
      let id = Number(shareHolders.length) + 2
      if (newShareHolder.ShareHolderId > 0){
        id = newShareHolder.ShareHolderId
        docs.forEach((p, i) => {
          if (p.ShareHolderId == newShareHolder.ShareHolderId) {
            docs.splice(i, 1);
          }
        });
      }
      const nShareHolder = 
        {
          ...newShareHolder, 
          ShareHolderId: id,
        }
      
    docs.push(nShareHolder)
      const postPerson = {
        ...person,
          ShareHolder: docs,
      };
        const body2 = {
          postPerson: postPerson,
          OnboardingId: onboarding,
        };
      services.fetchNewPerson(body2, response => {
        if (response && response.result && response.result.Code === 200) {
          setPersonData(body2.postPerson);
          setModalShareHolder({
            open: false,
            loading: false,
            initialShareHolder: undefined,
          });
          return { ...newShareHolder };
        } else {
          alert("Server Error"); 
          return { ...newShareHolder };
        }
      });

    }else{
    services.fetchUpdatePersonShareHolder(body, (response) => {
      if (response && response.result && response.result.Code === 200) {
        let newShareHolders = [...shareHolders];
        if (modalShareHolder.initialShareHolder === undefined) {
          newShareHolder.ShareHolderId = response.Id;
          newShareHolders.push(newShareHolder);
        } else {
          newShareHolders = shareHolders.map((s) => {
            if (parseInt(s.ShareHolderId, 10) === parseInt(newShareHolder.ShareHolderId, 10)) {
              return { ...newShareHolder };
            }
            return { ...s };
          });
        }
        setModalShareHolder({
          open: false,
          loading: false,
          initialShareHolder: undefined,
        });
        setPersonData({
          ...person,
          ShareHolder: newShareHolders,
        });
      }
    });
  }
  };

  const handleDeleteFile = (id) => {
    const body = {
      person: {
        PersonId: person.PersonId,
        ShareHolder: [{
          ShareHolderId: id,
        }],
      },
      edit: false,
    };
    setModalConfirm((m) => ({
      ...m,
      loading: true,
    }));
    if (onboarding){
      let docs = person.ShareHolder
      if (id > 0){
        docs.forEach((p, i) => {
          if (p.ShareHolderId == id) {
            docs.splice(i, 1);
          }
        });
      }
    const postPerson = {
      ...person,
        ShareHolder: docs,
    };
      const body2 = {
        postPerson: postPerson,
        OnboardingId: onboarding,
      };
      services.fetchNewPerson(body2, response => {
        if (response && response.result && response.result.Code === 200) {
          setPersonData(body2.postPerson);
          setModalConfirm({
            open: false,
            title: "",
            callback: undefined,
            loading: false
          });
          setModalNewPhone({
            ...modalNewPhone,
            loading: false,
            messageShow: false
          });
        }
    
      });

    }else{
    services.fetchUpdatePersonShareHolder(body, (response) => {
      if (response && response.result && response.result.Code === 200) {
        const newShareHolders = [...shareHolders];
        let index = -1;
        shareHolders.map((s, i) => {
          if (s.ShareHolderId === id) {
            index = i;
          }
          return {};
        });
        if (index > -1) {
          newShareHolders.splice(index, 1);
        }
        setPersonData({
          ...person,
          ShareHolder: newShareHolders,
        });
        setModalConfirm({
          open: false,
          shareHolderId: null,
          title: '',
          callback: undefined,
          loading: false,
        });
      }
    });
  }
  };

  const toggleModalConfirm = (id) => setModalConfirm((m) => {
    const newM = {
      ...m,
      open: !m.open,
      shareHolderId: id,
    };
    if (id) {
      newM.title = 'Are you sure you want to remove the selected Share Holder?';
      newM.callback = () => handleDeleteFile(id);
    }
    return newM;
  });

  const toggleModalShareHolder = (e, initialShareHolder) => setModalShareHolder((m) => ({
    ...m,
    open: !m.open,
    loading: false,
    initialShareHolder,
  }));

  const precheckSharedPercentage = () => {
    let percentage = 0;
    shareHolders.forEach((s) => {
      percentage += parseFloat(s.ShareHolderParticipationPercentage);
    });
    return (percentage >= 100);
  };

  if (!shareHolders) {
    return (
      <Spinner />
    );
  }
  return (
    <div>
      <Form>
        <FormGroup tag="fieldset">
          <ListGroup>
            {shareHolders.map((s) => (
              (Number(s.ShareHolderParticipationPercentage) === 0 || s.ShareHolderDescription !== '') &&
                <ListGroupItem
                key={s.ShareHolderId}
                onClick={(e) => toggleModalShareHolder(e, s)}
              >
                <Label>
                  <span style={{ fontSize: '15px', fontWeight: 500 }}>
                    {s.ShareHolderPersonName}
                    {':   '}
                  </span>
                  <span style={{ fontSize: '15px', fontWeight: 500 }}>
                    {s.ShareHolderDescription}
                    {'   '}
                  </span>
                  
                </Label>
                {userSession.IsReadOnly === false && <div style={{ cursor: 'pointer', float: 'right' }} onClick={(e) => { e.stopPropagation(); toggleModalConfirm(s.ShareHolderId); }}>
                  <i className="fa fa-trash" />
                </div>}
              </ListGroupItem> 
            ))}
          </ListGroup>
        </FormGroup>
      </Form>
      {userSession.IsReadOnly === false && <LaddaButton
        className="btn btn-ladda btn-primary"
        loading={false}
        style={{ marginRight: 10 }}
        onClick={toggleModalShareHolder}
        data-style={EXPAND_RIGHT}
      >
        <i className="fa fa-plus" />
        {' '}
        Add New Related Person
      </LaddaButton>}
      {modalShareHolder.open && (
        <ModalShareHolder
          {...modalShareHolder}
          onSave={handleSaveShareHolder}
          onToggle={toggleModalShareHolder}
          shareHolders={shareHolders}
          personId={person.PersonId}
          services={services}
          Link={Link}
          onboarding={onboarding}
          peopleRelated={true}
          userSession={userSession}
          headerText={modalShareHolder.initialShareHolder ? "Edit Share Holder" : "Add New Related People"}
        />
      )}
      <ModalConfirm
        open={modalConfirm.open}
        toggle={toggleModalConfirm}
        saving={modalConfirm.loading}
        callback={modalConfirm.callback}
        title={modalConfirm.title}
      />
    </div>
  );
};

RelatedPeopleTab.propTypes = {
  person: PropTypes.object.isRequired,
  shareHolders: PropTypes.array.isRequired,
  setPersonData: PropTypes.func.isRequired,
  services: PropTypes.object.isRequired,
};

export default RelatedPeopleTab;
